export const APP_ROUTES = {
  ABOUT: '/articles/about',
  ADVICE: '/fakta-och-rad',
  ASSOCIATION_PAGES: '/bransch-organisationer',
  BLOG: '/blogg',
  COOKIE_POLICY: '/articles/cookies',
  ETHICAL_POLICY: '/articles/ethical-policy',
  FAQ: '/faq-vanliga-fragor',
  GIFTCARD_CHECKOUT: '/presentkort',
  GIFTCARD_USE: '/giftcards',
  GIFTCARD_CONFIRMATION: '/giftcard/confirmation',
  PRIVACY_POLICY: '/articles/privacy-policy',
  SISTA_MINUTEN_SERP: '/sistaminuten',
  SUPPORT: '/support',
  TERMS: '/articles/terms',
  BOOKINGS: '/bokningar',
  FAVORITES: '/favoriter',
  CANCEL_BY_CODE: '/cancel',
  WELLNESSCARD_CHECKOUT: '/friskvardskort',
} as const;
